import { atom } from 'jotai';

export type BackgroundOperation = {
  id: string;
  kind: 'rename' | 'bulkReassign';
  label: string;
  status: 'running' | 'success' | 'error' | 'cancelled';
  total: number;
  completed: number;
  failedIds: string[];
  errorMessages: string[];
  startedAt: number;
  finishedAt?: number;
  cancel?: () => void;
};

export const backgroundOperationsAtom = atom<BackgroundOperation[]>([]);
